// components
import Button, { Link } from "../button/Button";
import { useTriggerState } from "../modal/Modal";

// styles
import "./cartNavigation.styles.scss";

const CartNavigation = () => {
  const StayHereButton = () => {
    const { onClick } = useTriggerState();

    return (
      <Button className="_btn-flip" onClick={onClick}>
        Stay Here
      </Button>
    );
  };
  return (
    <div className="cartNavigation">
      <StayHereButton />
      <Link className="_btn no-padding" href={"/cart"}>
        View Cart
      </Link>
    </div>
  );
};

export default CartNavigation;
